import { LicenseInfo } from '@mui/x-data-grid-pro';

// Add your license key here
LicenseInfo.setLicenseKey('18fa77cafe7356d88ee6bc8e49591060Tz0xMjY4ODAsRT0xODA0OTgyMzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=');